import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Validate from '../lib/validate';
import Settings from '../lib/settings';
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';
import * as Actions from '../actions';
import {connect} from 'react-redux';

class AddArticle extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      article: '',
      slug: '',
      editorState: EditorState.createEmpty(),
      formMessage: [],
      isUpdating: false,
      canScroll: false
    };

    this.handleChange = this.handleChange.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);

    //this.addFormMessage = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (typeof this.props.match.params.slug !== "undefined") {
      fetch('/api/articles/' + this.props.match.params.slug, Settings.fetchParams('GET')).then(res => res.json()).then(json => {
        if (json === null) {
          this.setState({isUpdating: false});
        } else {
          this.setState(json);
          this.setState({isUpdating: true});
          const contentBlock = htmlToDraft(json.article);
          if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.setState({editorState});
          }
        }
      });
    }

    window.scrollTo(0, this.props.menuPosition);
  }

  componentWillReceiveProps(newProps) {
    window.scrollTo(0, this.props.menuPosition);
    if (typeof newProps.match.params.slug === "undefined") {

      this.setState({
        name: '',
        article: '',
        editorState: EditorState.createEmpty(),
        isUpdating: false,
        canScroll: false
      });

    }


  }


  onEditorStateChange: Function = (editorState) => {
    this.setState({editorState});
    ReactDOM.findDOMNode(this.refs["article"]).classList.remove(Settings.wrongInput);
    //console.log(convertToRaw(this.state.editorState.getCurrentContent()));
  };

  addWrongInputClass(name) {
    ReactDOM.findDOMNode(this.refs[name]).classList.add(Settings.wrongInput);
  }

  addFormMessage(message) {

    this.setState(prevState => ({
      formMessage: [
        ...prevState.formMessage,
        message
      ],
      canScroll: true
    }));
  }

  handleChange(event) {

    this.setState({
      [event.target.name]: event.target.value
    });
    ReactDOM.findDOMNode(this.refs[event.target.name]).classList.remove(Settings.wrongInput);
  }


  handleSubmit(event) {

    event.preventDefault();
    let errorCheck = true;

    let descriptionHtml = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));

    this.setState({formMessage: []});

    if (!Validate.article(this.state.name, "name")) {
      this.addFormMessage("Pro přidání článku prosím vyplňte název");
      errorCheck = false;
      this.addWrongInputClass("name");
    }

    if (!Validate.article(descriptionHtml, "article")) {
      this.addFormMessage("Pro přidání článku prosím vyplňte článek");
      errorCheck = false;
      this.addWrongInputClass("article");
    }

    if (errorCheck) {
      this.props.dispatch(Actions.loader(true));


        let article = {
          name: this.state.name,
          article: descriptionHtml
        };

        if(this.state.isUpdating) {
          article.slug = this.state.slug
        }

        if (Validate.article(article, "for_insert")) {

          var sucessText;
          if(this.state.isUpdating) {
            sucessText = "Změny uloženy!";
          } else {
            sucessText = "Článek přidán!";
          }

          var fetchAdd;
          if(this.state.isUpdating) {
            fetchAdd = '/api/articles/' + this.state.slug;
          } else {
            fetchAdd = '/api/articles';
          }


          fetch(fetchAdd, Settings.fetchParams('POST', article)).then(res => {
            this.props.dispatch(Actions.loader(false));
            if (res.ok) {
              res.json().then(json => {
                if (!json.error) {
                  window.scrollTo(0, this.props.menuPosition);
                  ReactDOM.findDOMNode(this.refs.addProduct).innerHTML = '<h2 class="addSuccess">' + sucessText + '</h2>';
                } else {
                  console.log("Error");
                }
              })
            } else {
              alert("Error");
            }
          });

        } else {
          alert("Vyplňte korektně formulář..");
        }

    }

  }

  render() {

    if(this.state.formMessage.length > 0 && this.state.canScroll) {
      window.scrollTo(0, this.props.menuPosition);
      this.setState({
        canScroll: false
      });
    }

    const formErrorMessages = this.state.formMessage.map((item, index) => <p key={index}>{item}</p>);


    return (<div className="form">
      <div ref="addProduct">
        <h1>
          {
            this.state.isUpdating
              ? "Upravit "
              : "Přidat "
          }článek:
        </h1>

        <div className="formErrorMessages">
          {formErrorMessages}
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col100">
              <div className="formLabel">Název článku</div>
              <div className="formInput"><input type="text" name="name" ref="name" value={this.state.name} onChange={this.handleChange} required="required"/></div>
            </div>
            <div className="col100">
              <div className="formLabel">Článek</div>
              <div className="formTextarea" ref="article">
                <Editor editorState={this.state.editorState} wrapperClassName="description-wrapper" editorClassName="description-editor" onEditorStateChange={this.onEditorStateChange} toolbar={{
                    options: [
                      'inline',
                      'blockType',
                      'fontSize',
                      'list',
                      'textAlign',
                      'link',
                      'embedded',
                      'remove',
                      'history'
                    ],
                    inline: {
                      inDropdown: false,
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                      options: ['bold', 'italic', 'underline', 'strikethrough']
                    },
                    list: {
                      options: ['unordered', 'ordered']
                    }
                  }}/>
              </div>
            </div>

          </div>
        </form>

        <div className="col100">
          <button type="submit" onClick={this.handleSubmit}>{
              this.state.isUpdating
                ? "Uložit změny"
                : "Přidat článek"
            }</button>
        </div>
      </div>
    </div>);
  }
}
function mapStateToProps(state){
  return {
    admin: state.admin,
    menuPosition: state.menuPosition,
  };
}
export default connect(mapStateToProps)(AddArticle);



// WEBPACK FOOTER //
// ./src/pages/AddArticle.js